import React from 'react'
import { formatCurrency } from '../../../../../../common/helpers'
import { StyledSpan } from '../../../../../../theme/Global'

const CellAmountRenderer = ({ amount, jurisdiction, jurisdictionName, indexed }) => {
  const name = jurisdiction !== 'federal' ? `of ${jurisdictionName}` : ''

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1)

  return indexed
    ? (
      <StyledSpan data-testid="mw-notification-wage-amount-cell">
        Indexed
      </StyledSpan>
    )
    : (
      <StyledSpan data-testid="mw-notification-wage-amount-cell">
        {amount ? (`${formatCurrency(amount, 'Indexed')} ${capitalize(jurisdiction)} ${name}`) : 'No Change'}
      </StyledSpan>
    )
}

export default CellAmountRenderer
